module.exports = __webpack_public_path__ + "img/floorOne.97de01d2.png";